module.exports = __webpack_public_path__ + "static/media/utas.590d79a5.svg";